import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';
import rem from 'polished/lib/helpers/rem';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';

export const PageSection = styled(Flex)`
  flex-direction: column;
  width: 100%;
  max-width: ${rem(760)};
  padding: ${rem(spacing.base * 1.5)};
  gap: ${rem(spacing.base)};
`;

export const EntryCard = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 0.5)};
  padding: ${rem(spacing.base * 1.25)};
  background: ${toColorString(color.base.snowWhite)};
  border: ${rem(1)} solid ${toColorString(color.opacity.charcoal15)};
  border-radius: ${rem(2)};
`;

export const EntryMeta = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
`;

export const EntryDate = styled(P)`
  color: ${toColorString(color.base.alaskanHusky)};
  margin: 0;
`;

export const EntryDescription = styled(P)`
  margin: 0;
`;

export const EmptyState = styled(P)`
  color: ${toColorString(color.base.alaskanHusky)};
`;
